/*
* Shifts timestamps/datetimes across timezones to account for incorrect
* timezone data in database. The database stores timestamps in the local
* timezone, but labels them as if they are UTC. If that is corrected,
* this module will no longer be necessary.
*/
import moment from 'moment-timezone'
import config from './config'

/* Strip timezone data from a datetime (or timestamp). */
const stripTimezone = (datetime) => moment.utc(datetime).format('YYYY-MM-DD kk:mm')

/* Parse timestamp (from database) with corrected timezone data. */
const parse = (timestamp) => {
  return moment.tz(stripTimezone(timestamp), config.timezone)
}

/* Revert timezone correction on datetime object (or timestamp) for querying database. */
const format = (datetime) => {
  const timezoned = moment.tz(datetime, config.timezone)
  const stripped = stripTimezone(timezoned)
  const shifted = moment.utc(stripped)
  return shifted.format()
}

export default {
  parse,
  format
}